import React, { useEffect, useState } from "react";
import AlertBanner from "da-frontend-shared-ui-components/lib/AlertBanner";

const ALERTPATH = process.env.REACT_APP_ALERTPATH || (
  process.env.NODE_ENV === "development" ? "/api/dashboard/v1/alerts/PowerCommandCloud" : ""
);

type Banner = { loaded: false } | {
  loaded: true
  htmlContent: string
};

const useAlertBannerData = (path: string, dismissed: boolean): Banner => {
  const [ banner, setActiveBanner ] = useState<Banner>({ loaded: false });

  useEffect(() => {
    if (!dismissed)
      fetch(path).then(async response => {
        if (response.ok) {
          const responseJson = await response.json();
          if (responseJson.message && responseJson.message.length > 0) {
            setActiveBanner({
              loaded: true,
              htmlContent: responseJson.message
            });
          }
        }
      });


  }, [ path, setActiveBanner, dismissed ]);

  return banner;
}

/**
 * Display an alert if there is one active
 */
const Alert = () => {
  const [dismissed, setDismissed] = useState(
    sessionStorage && sessionStorage.getItem("alertdismissed") ? true : false
  );

  const banner = useAlertBannerData(ALERTPATH, dismissed);

  /// Set dismissed and store preference for duration of session
  const storeDismissed = () => {
    sessionStorage && sessionStorage.setItem("alertdismissed", "true");
    setDismissed(true);
  }

  if (banner.loaded && !dismissed) {
    return <AlertBanner messageHtml={banner.htmlContent} showClose={true} onClose={storeDismissed} />
  }

  return <></>;
}

export {
  Alert
}